<template>
  <Modal
    :modal="profileDescriptionModalRef"
    :steps="[{ component: ProfileDescriptionModalContent, id: 'description' }]"
  />
</template>

<script lang="ts" setup>
import ProfileDescriptionModalContent from './profile-description-modal-content/profile-description-modal-content.vue'

import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetProfileDescriptionModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const profileDescriptionModalRef = selectGetProfileDescriptionModal(modalsStore)
</script>
